import { grey } from '../../../common/styles/colours';
import { boxShadows } from '../../../common/styles/boxShadows';
export var DropdownListStylePropertiesByVariant = {
    default: function (theme) {
        var _a, _b, _c;
        return ({
            backgroundColor: (_a = theme.backgroundUI) !== null && _a !== void 0 ? _a : grey[0],
            boxShadow: boxShadows[400],
            optionBackgroundActive: (_b = theme.hoverOverlayPrimary) !== null && _b !== void 0 ? _b : grey[100],
            // The following property is specific to the dropdown list in Dropdown
            optionPrefixLabel: (_c = theme.contentAccessory) !== null && _c !== void 0 ? _c : grey[600],
        });
    },
};
//# sourceMappingURL=DropdownListStylePropertiesByVariant.js.map